import { createClient, type SupabaseClient } from "@supabase/supabase-js";

export type PublicSupabaseConfig = {
  url: string;
  publishableKey: string;
};

export let supabase: SupabaseClient;

export function configureSupabase(config: PublicSupabaseConfig): void {
  supabase = createClient(config.url, config.publishableKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });
}
